import React, { Fragment, useState } from "react";
import { Table, Tag } from "antd";

// Images
import searchIcon from "@Images/icons/icon-search.png";
import Ai from "@Images/ai.png";

// Components
import H3Image from "../../../../../uilib/h3Image";
import H3Button, { defaultButtonTypes } from "../../../../../uilib/h3Button";
import H3Text from "../../../../../uilib/h3Text";
import AccountPayableInvoiceListTableColumns from "./AccountPayableInvoiceListTableColumns";

// Hooks
import useCheckPortrait from "../../../../../hooks/useCheckPortrait";
import AccountPayableInvoiceListTableTitle from "./AccountPayableInvoiceListTableTitle";

const AccountPayableInvoiceListTable = ({
  setCurrentPage,
  setLimit,
  data,
  visibleColumns,
  currentPage,
  limit,
  isLoading,
  user,
  priceMasking,
  MONEY,
  showFilters,
  setShowFilters,
  openPopover,
  setOpenPopover,
  startDate,
  endDate,
  fixedColumns,
  customFieldsProps,
  setStartDate,
  setEndDate,
  setVisibleColumns,
  pushParamsToUrl,
  searchKeyword,
  filterState,
  setApInvoiceSelectedIntervalDateRangeType,
  apInvoiceSelectedIntervalDateRangeType,
  selectedEmails,
  setSelectedEmails,
  setMoreDetailsDrawer,
  setSelectedAPInvoice,
}) => {
  const { isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait } =
    useCheckPortrait();

  return (
    <Fragment>
      <div className="doc-list__table-wrapper">
        <Table
          title={() =>
            AccountPayableInvoiceListTableTitle({
              showFilters,
              setShowFilters,
              openPopover,
              setOpenPopover,
              data,
              startDate,
              endDate,
              visibleColumns,
              fixedColumns,
              setVisibleColumns,
              setStartDate,
              setEndDate,
              setApInvoiceSelectedIntervalDateRangeType,
              apInvoiceSelectedIntervalDateRangeType,
              pushParamsToUrl,
              searchKeyword,
              filterState,
              limit,
            })
          }
          bordered
          showHeader
          loading={isLoading}
          size="small"
          columns={AccountPayableInvoiceListTableColumns({
            isMobile,
            visibleColumns,
            user,
            priceMasking,
            MONEY,
            isPortrait,
            customFieldsProps,
            setStartDate,
            setEndDate,
            pushParamsToUrl,
            setMoreDetailsDrawer,
            setSelectedAPInvoice,
          })}
          dataSource={data?.data}
          currentPage
          scroll={
            !isMobileOrPortrait && !!data?.data?.length
              ? { x: "max-content", y: "calc(100dvh - 180px)" }
              : { x: "max-content" }
          }
          sticky={!isMobileOrPortrait && !!data?.data?.length}
          pagination={{
            defaultCurrent: currentPage,
            current: currentPage,
            total: data ? data.count : 0,
            pageSize: limit,
            onChange: (page, pageSize) => {
              setCurrentPage(page);
              setLimit(pageSize);
              pushParamsToUrl({
                currentKeyword: searchKeyword,
                page: page,
                currentLimit: pageSize,
                filterState,
                startDate,
                endDate,
              });
            },
            position: ["bottomLeft"],
            showTotal: (tot, range) =>
              `${range[0]}-${range[1]} of ${tot} items`,
            showSizeChanger: true,
            pageSizeOptions: [10, 25, 50, 100],
          }}
        />
      </div>
    </Fragment>
  );
};

export default AccountPayableInvoiceListTable;
